'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var randomUniqueHash = exports.randomUniqueHash = function randomUniqueHash() {
  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
  return Math.random().toString(36).split('').filter(function (value, index, self) {
    return self.indexOf(value) === index;
  }).join('').substr(2, length);
};


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/ristoranti-lib/lib/utils/string.js
// module id = 436
// module chunks = 0